import { Box } from '@mui/material';
import styled from 'styled-components';
import { media } from '../../theme/breakpoints';

export const StyledContainer = styled(Box)`
    padding: 32px;
    max-width: 1200px;
    background: #ffffff;
    border: 1px solid rgba(224, 224, 224, 1);
    margin: 0 auto;
    border-radius: 40px;
    position: relative;
    width: 90%;

    ${media.md} {
        padding: 64px;
    }
`;

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;

    h2 {
      margin: 0;
      font-size: 20px;
    }

    ${media.sm} {
      h2 {
        font-size: 22px;
      }
    }
`;

export const ControlsWrapper = styled(Box)`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    align-items: start;
    margin-bottom: 2rem;

    ${media.md} {
      grid-template-columns: 1fr 1fr;
    }
`;
